<!--<link rel="stylesheet" href="../assets/layout/sass/_login.scss">-->
<template>
    <div :class="containerClass">
        <app-forgot></app-forgot>
    </div>
</template>

<script>
    import AppForgot from '../components/Forgot';

    export default {
        name: "Forgot",
        computed: {
            containerClass() {
                return ['layout-wrapper', {
                    'layout-dark': this.$store.state.theme === 'dark',
                    'layout-light': this.$store.state.theme === 'light',
                }];
            },
        },
        components: {
            'AppForgot': AppForgot,
        }
    }

</script>

<style lang="scss">
    @import '../App.scss';

</style>